import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './icon-button.module.css';
export default forwardRef(function IconButton(props, ref) {
    const { icon, children, ...rest } = props;
    return (_jsxs("button", { className: styles.root, type: "button", ...rest, ref: ref, children: [_jsx("i", { className: icon }), children && _jsx("span", { children: children })] }));
});
